import LiveMapper from './live-mapper';
import PeriodScoreModel from '../period-score/period-score-model';

const LiveModel = {
    mapper: LiveMapper,

    awayTeamCurrentPeriodScore: {
        fieldName: 'w',
        type: Number,
    },

    awayTeamRedCards: {
        fieldName: 'y',
        type: Number,
    },

    awayTeamScore: {
        fieldName: 'a',
        type: Number,
    },

    currentPeriodNumber: {
        fieldName: 'c',
        type: Number,
    },

    eventTime: {
        fieldName: 'e',
        type: String,
    },

    eventTimeInMinutes: {
        fieldName: 'v',
        type: Number,
    },

    homeTeamCurrentPeriodScore: {
        fieldName: 'o',
        type: Number,
    },

    homeTeamRedCards: {
        fieldName: 't',
        type: Number,
    },

    homeTeamScore: {
        fieldName: 'h',
        type: Number,
    },

    matchStatusCode: {
        fieldName: 'm',
        type: Number,
    },

    periodScores: {
        fieldName: 'p',
        model: PeriodScoreModel,
        type: Array,
    },

    remainingTimeInPeriod: {
        fieldName: 'r',
        type: String,
    },

    stoppageTime: {
        fieldName: 's',
        type: String,
    },
};

export default LiveModel;
